import Card from '@carvana/ds-card';
import React from 'react';
import { SevenDayBanner } from '|/components/seven-day-banner';
import styles from './payment-details-card.module.css';
import { usePaymentContext } from '../../../contexts/payment';
import { PaymentBreakdown } from '../payment-breakdown';
import { TotalVehiclePrice } from '../total-vehicle-price';

export const PaymentDetailsCard = () => {
  const {
    state: {
      paymentSummary: {
        paymentType,
        purchasePaymentBreakdown: { shippingFee }
      }
    }
  } = usePaymentContext();

  const isCash = paymentType === 'Cash';

  const shouldShowTotalVehiclePrice = !isCash || shippingFee === 0;

  return (
    <Card showBorder={false} className={styles.card}>
      <div className={styles.breakdownContent}>
        {shouldShowTotalVehiclePrice && <TotalVehiclePrice />}

        <PaymentBreakdown />
      </div>

      <SevenDayBanner compact />
    </Card>
  );
};
